import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import councilof50 from '../../Assets/Img/councilof50.jpg'

const Chap23 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap22">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap24">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 23: Council of Fifty and King Over All the Earth</h1>

      <img src={councilof50} className='image' alt='Joseph Smith and Hyrum Smith in Nauvoo' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>Joseph stated, “I calculate to be one of the instruments of setting up the kingdom of Daniel by the word of the Lord, 
            and I intend to lay a foundation that will revolutionize the whole world.”  
            <btn id="clickable1" className="footnote">1  </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>Statement on 12 May 1844 to the Council of Fifty, as recorded in Underwood, the Millenarian World of Early Mormonism, 109.</Tooltip>
            
            Joseph believed he had succeeded, stating near the end of his life, “Hallelujah, hallelujah, hallelujah! … I have done 
            what king Solomon, King Hiram, & Hiram Abiff could not do: I have set up the kingdom no more to be thrown down forever 
            nor never to be given to another people.”
            <btn id="clickable2" className="footnote">2  </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Dimick Huntington, Statement of Dimick Huntington, December 12, 1878, Salt Lake City.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph was not a quitter. Six years after being forced out of Missouri in 1838, without establishing the holy city of Zion, 
            in March 1844 Joseph organized the Council of Fifty – the governmental structure of the Kingdom of God.  
            <btn id="clickable3" className="footnote">3  </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Andrew Ehat, Joseph Smith’s Introduction of Temple Ordinances, p. 102, 103, 178-179, 219.</Tooltip>

            Four months later, he would be murdered.
          </p>
        </div>

        <div className='paragraph'>
          <p>Mormon apostle Russell Ballard stated that the church has never hidden anything from its members, “… it is not the Lord’s way.”
          <btn id="clickable4" className="footnote">4  </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>November 2018 Face to Face Young Adult broadcast.</Tooltip>

           But when it comes to Council of Fifty minutes, for which historians have been requesting access for decades, the church kept these documents hidden for more than 150 years. The church finally granted access to these materials in 2016 as part of the Joseph Smith Papers Project.  The Council of Fifty minutes lift the lid on Joseph’s secret designs for building a theocracy and shed light on the circumstances of his murder.
          </p>
        </div>

        <h2 className="headlinePadding">Constitutional Structure of the Kingdom of God</h2>

        <div className='paragraph'>
          <p>Joseph and the Council of Fifty believed they had a divine mandate to establish a constitutional structure of a temporal 
            Kingdom of God. The Council’s stated purpose was “to organize the political kingdom of God in preparation for the Second 
            Coming of Christ.”  
            <btn id="clickable5" className="footnote">5  </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Church History in the Fulness of Times, 270.</Tooltip>
            
            The kingdom they were establishing would serve as the foundation for Christ’s Millennial government. This Kingdom would serve as an umbrella of divine authority, ruling all nations, implementing the laws of God. Each nation would be free to govern itself if it governed within the bounds of the Mormon theocracy. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph received the name of the council by revelation, “Verily thus saith the Lord, this is the name by which you shall 
            be called, The Kingdom of God and His Laws, With the Keys and Power Thereof, and Judgement in the Hands of His Servants.”  
            <btn id="clickable6" className="footnote">6  </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Joseph Smith Papers, Administrative Records, p. 45.</Tooltip>
            
            The name was shortened to Council of Fifty because 50 men eventually were admitted to the Council, witnessing Joseph’s ordination as “King, Priest, and Ruler over Israel on the Earth” – and the placing of a crown upon his head.
          </p>
        </div>

        <div className='paragraph'>
          <p>Nauvoo Stake President William Marks stated, “I was also witness of the introduction (secretly) of a kingly form of 
            government, in which Joseph suffered himself to be ordained a king, to reign over the house of Israel forever.”  
            <btn id="clickable7" className="footnote">7  </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>William Marks, Zion's Harbinger and Baneemy's Organ, St. Louis, July 1853, p. 53.</Tooltip>
            
            George Miller remarked, “In this council we ordained Joseph Smith as King on earth.”  
            <btn id="clickable8" className="footnote">8  </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Klaus Hansen, The Theory and Practice of the Political Kingdom of God in Mormon History, 1829-1890, master's thesis, BYU, 1959, typed copy, p. 114..</Tooltip>

            Council secretary William Clayton recorded, “… Joseph was chosen as our prophet, priest & king by hosanas.”  
            <btn id="clickable9" className="footnote">9  </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>William Clayton Journal, 11 April 1844, 1 January 1845, quoted in Allen, “One Man’s Nauvoo,” footnotes 21 and 22.</Tooltip>
            
            In a revelation given to the third prophet of the Mormon Church John Taylor, “mention is made of Joseph Smith being crowned a king 
            in Nauvoo.”
            <btn id="clickable10" className="footnote">10  </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Diary of George A. Smith, May 9,1844, located in the Library of the Church Historian; Kenneth W. Godfrey, former director of the LDS Institute at Stanford University, BYU Studies, Winter 1968, p. 212-13, quoted in doctoral dissertation Causes of Mormon Non-Mormon Conflict in Hancock County, Illinois, 1839-1846, Ph.D. dissertation, BYU, 1967, pp. 63-65.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>In a veiled reference to Smith’s kingship, apostles Lyman Wight and Heber Kimball wrote to Joseph in 1844 that “you are 
            already President ‘Pro Tem’ (Latin for the time being) of the world.”  
            <btn id="clickable11" className="footnote">11  </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Lyman Wight and Heber C. Kimball to Joseph Smith, 19 June 1844, LDS archives. </Tooltip>
            
            Joseph cautioned council members, “It is not wisdom to use the term ‘king’ ... Let us use the term ‘proper source’ instead 
            of ‘king’ and it will be all understood, and no person can take advantage.”
            <btn id="clickable12" className="footnote">12  </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Council of Fifty, Minutes, April 18, 1844, 128.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Before forming the Council of Fifty on 27 August 1843, Joseph linked his temple ordinances with theocracy. “Those holding 
            the fullness of the M. Priesthood are kings and priests of the most high God, holding the keys of power and blessings … 
            A perfect law of theocracy holding keys of power and blessings as God to give laws to the people.”
            <btn id="clickable13" className="footnote">13  </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>History of the Church, 5:555.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>With Joseph as King, Council of Fifty members were considered Princes. Joseph promised Council members that they would 
            govern and rule the worldly kingdoms as “princes” as well as “priests and kings” – promises hearkening to Joseph’s temple 
            ceremonies.  At times, the Council of Fifty referred to themselves as “princes in the Kingdom of God,” and “fifty princes of 
            the Kingdom.”  
            <btn id="clickable14" className="footnote">14  </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Miller to Dear Brother, 27 June and 28 June 1855, published in the Northern Islander.</Tooltip>
            
            To keep the Council of Fifty secret, Joseph administered an oath of secrecy under the penalty of death.  
            <btn id="clickable15" className="footnote">15  </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>William Clayton Diary, 1 Mar. 1845, in Smith, An Intimate Chronicle, 158.</Tooltip>
            
            A few months later, 
            several members violated that oath, and the aims of the Council of Fifty would be made known, leading to Joseph’s death.
          </p>
        </div>

        <h2 className="headlinePadding">One Theocracy to Rule Them All</h2>

        <div className='paragraph'>
          <p>Joseph revealed that it was God’s will that this secret group was to receive, “… from this time henceforth and forever, 
            Joseph Smith, as our Prophet, Priest & King, and uphold him in that capacity in which God has anointed him.”  
            <btn id="clickable16" className="footnote">16  </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Council of Fifty, Minutes, April 11, 1844, 95–96.</Tooltip>

            The Kingdom of God on earth now had a King in Joseph Smith until Christ would come to rule on earth. Joseph assigned a 
            committee to write a constitution, which included statements such as “… the supreme law of the land shall be the word of 
            Jehovah.”  
            <btn id="clickable17" className="footnote">17  </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 154.</Tooltip>
            
            “All power emanates from God … and he alone has the right to govern the nations and set in order the kingdoms of this world.”
            <btn id="clickable18" className="footnote">18  </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 146.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>The committee wrote that current governments and nations are illegitimate because “none of the nations, kingdoms or 
            governments of the earth do acknowledge the creator of the Universe as their Priest, Lawgiver, King and Sovereign, neither 
            have they sought unto him for laws by which to govern themselves.”  
            <btn id="clickable19" className="footnote">19  </btn>
            <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 147.</Tooltip>
            
            In the constitution, Lord announces that he rules “the armies of heaven above, and among the nations of the earth beneath.”  
            <btn id="clickable20" className="footnote">20  </btn>
            <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 153.</Tooltip>
 
            God is quoted saying that “I alone am the rightful law giver of man.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Because the Mormons believed Joseph was the only prophet on earth and the sole mouthpiece of God, they felt justified in 
            making such statements in their constitution. The constitution stated, “I the Lord will do nothing but what I have revealed 
            or shall reveal unto my servants the prophets and I have appointed one man, holding the keys and authority, pertaining to my 
            holy priesthood, to whom I will reveal my laws, my statutes, my ordinances, my Judgements, my will and pleasure concerning my 
            kingdom on the earth.
            <btn id="clickable21" className="footnote">21  </btn>
            <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 152.</Tooltip>

          </p>
        </div>

        <div className='paragraph'>
          <p>The constitution was never completed. In April 1844, Joseph “advised that we let the constitution alone.”  
          <btn id="clickable22" className="footnote">22  </btn>
            <Tooltip anchorSelect="#clickable22"className="footnote-size"  clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 216.</Tooltip>

            Joseph put forth the revelation, “Verily thus saith the Lord, ye are my constitution, and I am your God, and ye are my 
            spokesmen. From henceforth do as I shall command you. Saith the Lord.”
            <btn id="clickable23" className="footnote">23  </btn>
            <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 216.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">Council of Fifty Not Symbolic</h2>

        <div className='paragraph'>
          <p>At the time Joseph organized the Council of Fifty he had an army of the Nauvoo Legion at his command, which was larger than the state militia. He had a secret police force of oath-bound Danites to protect him. The Nauvoo courts were in his pocket as he had written the city charter to guarantee he was untouchable from extradition by lawsuit and criminal prosecution for past crimes. He was the mayor. He had numerous wives and alliances through those marriages with the elite of Mormonism. He had made covenants with his closest followers, promising them that through obedience to him as prophet they would one day be kings and priests, and queens and priestesses. No wonder at this time, the Illinois state legislature was debating repealing the Nauvoo charter.
          </p>
        </div>

        <div className='paragraph'>
          <p>Today, the Mormon church claims that the activities of the Council of Fifty were merely symbolic. The church claims that the governmental structure was simply fanciful thinking and that it would be organized officially at the return of Christ. Other times, the church claims the Council of Fifty’s purpose was to support Joseph’s bid as a candidate for the U.S. presidency. Both ideas are distortions of the true purpose and intent of the Council of Fifty, of which the modern church leaders and historians are aware.
          </p>
        </div>

        <div className='paragraph'>
          <p>We will see later the Mormons, under Joseph’s leadership, were laying out real plans with real objectives to establish a 
            literal kingdom that would rule all nations of the world until Christ appeared. According to historian Klaus Hansen, members 
            of the Council of Fifty believed it was their divinely appointed mission to follow Joseph’s violent, apocalyptic vision of 
            ruling the world as a theocracy to destroy the wicked kingdoms of the world in establishing the Mormon Kingdom of God on 
            the earth.
            <btn id="clickable24" className="footnote">24  </btn>
            <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>Klaus Hansen, Quest for Empire: The Political Kingdom of God and the Council of Fifty in Mormon History, 1967, P. 61, 66, 200. Page 223 for the names of this council in 1844.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Council of Fifty secretary William Clayton recorded that one meeting, “He [Smith] prophesied the entire overthrow of this 
            nation [United States] in a few years.”  
            <btn id="clickable25" className="footnote">25  </btn>
            <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>William Clayton Journal, 11 April and 13 April 1844, Michael Quinn Papers, Beinecke Rare Book and Manuscript Library, Yale University.</Tooltip>

            Joseph taught the Council of Fifty that the wicked and corrupt nations of the world would destroy themselves through violence and bloodshed. The only safety and refuge would be in the Mormon Zion in Jackson County.
          </p>
        </div>

        <div className='paragraph'>
          <p>In 1855, fourth Mormon prophet Wilford Woodruff stated, “Those judgments have begun, that will never leave the earth until 
            it is swept as with the besom of destruction, until thrones are cast down and kingdoms overthrown, until each man draws his 
            sword against his neighbor, and every nation and kingdom that exists will be at war with each other, except the inhabitants 
            of Zion. The Lord has spoken it.
            <btn id="clickable26" className="footnote">26  </btn>
            <Tooltip anchorSelect="#clickable26" className="footnote-size" clickable>Wilford Woodruff, Journal of Discourses, Feb. 25, 1855, vol. 2, p. 201.</Tooltip>

          </p>
        </div>

        <div className='paragraph'>
          <p>As the Gentile power structures of the nations are toppled, the Council of Fifty and Mormon church would produce the 
            government of Zion to rule over all other governments. In 1855, Brigham stated, “The Church of Jesus Christ will produce 
            this government, and cause it to grow and spread, and it will be a shield round about the Church. And under the 
            influence and power of the Kingdom of God, the Church of God will rest secure and dwell in safety … The Kingdom of 
            God will do this, it will control the kingdoms of the world.”  
            <btn id="clickable27" className="footnote">27  </btn>
            <Tooltip anchorSelect="#clickable27" className="footnote-size" clickable>Brigham Young, Journal of Discourses, June 3, 1855, vol. 2, p. 316-17.</Tooltip>
    
            Brigham continued, “And you may pile on state after state, and kingdom after kingdom, and all hell on top, and we will 
            roll on the Kingdom of our God, gather out the seed of Abraham, build the cities and temples of Zion, and establish the 
            Kingdom of God to bear rule over all the earth.”
            <btn id="clickable28" className="footnote">28  </btn>
            <Tooltip anchorSelect="#clickable28" className="footnote-size" clickable>Brigham Young, Journal of Discourses, June 3, 1855, vol. 2, p. 316-17.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>In 1857, third Mormon prophet Wilford Woodruff stated, “… the day is nigh at hand when He will make bare His arm of power and 
            show the world that there is a God in Israel, who will no longer bear the blasphemies of the wicked without bringing them to 
            judgment, but He will send forth those angels, those messengers who dwell in the presence of God, who are waiting with their 
            sharp sickles in their hands to reap down the earth.”
            <btn id="clickable29" className="footnote">29  </btn>
            <Tooltip anchorSelect="#clickable29" className="footnote-size" clickable>Wilford Woodruff, Journal of Discourses, February 22, 1857, vol. 4, p. 231.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Simply put, Joseph and his Council of Fifty were religious radicals, with treasonous intent on overthrowing the United States 
            government because the Gentiles had rejected the Mormon gospel and were ripe for destruction. According to the Book of Mormon, 
            the American continent had been given to the Lamanites (Native Americans) as a land of their inheritance as they were of the 
            House of Israel – the rightful heirs to the Kingdom of God. In 3 Nephi, the resurrected Christ preached, “And behold, this 
            people (future Lamanites) will I establish in this land (America), unto the fulfilling of the covenant which I made with your 
            father Jacob; and it shall be a New Jerusalem. And the powers of heaven shall be in the midst of this people; yea, even I 
            will be in the midst of you.”
            <btn id="clickable30" className="footnote">30  </btn>
            <Tooltip anchorSelect="#clickable30" className="footnote-size" clickable>3 Nephi 20:21–22.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Later, Christ warns the Gentile who do not repent that they will be destroyed by the Lamanites, Native Americans of their 
            day, to make way for this New Jerusalem. “… lest a remnant of the seed of Jacob shall go forth among you as a lion among the 
            beasts of the forest, as a young lion among the flocks of sheep, who, if he go through both treadeth down and teareth in 
            pieces, and none can deliver … Yea, wo be unto the Gentiles except they repent … saith the Father, that I will cut off thy 
            horses out of the midst of thee, and I will destroy thy chariots; And I will cut off the cities of thy land, and throw down 
            all thy strongholds ... And it shall come to pass, saith the Father that the sword of my justice shall hang over them at 
            that day; and except they repent it shall fall upon them.”
            <btn id="clickable31" className="footnote">31  </btn>
            <Tooltip anchorSelect="#clickable31" className="footnote-size" clickable>3 Nephi 20: 15-17, 20.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>To Joseph and the Council of Fifty, their justification for the forthcoming bloodshed at the hands of the Native Americans was that the Gentile nation of the United States had rejected the Mormon gospel. As prophesied in the Book of Mormon, now was the time for the Mormons and the Native Americans to descend upon the Gentiles and destroy them to cleanse the land in preparation for the return of Christ. The Book of Mormon prophesies that the Native Americans under the direction of God will destroy the Gentiles (anyone not of the House of Israel) unless they “repent,” meaning embrace the Mormon gospel. 
          </p>
        </div>

        <h2 className="headlinePadding">Brigham’s Coronation as King of the World</h2>

        <div className='paragraph'>
          <p>After Joseph’s death, Brigham reconvened the Council of Fifty in February 1845. Brigham served as chairman of the Council 
            of Fifty until on 12 February 1849, when he was anointed as its leader – the “king and president” of the Kingdom of God.  
            <btn id="clickable32" className="footnote">32  </btn>
            <Tooltip anchorSelect="#clickable32" className="footnote-size" clickable>See minutes of meeting of Quorum of the Twelve Apostles, 12 February 1849, p. 3 [LDS Archives], cited in Michael Quinn 1997, p. 238. Michael Quinn (1997), The Mormon Hierarchy: Extensions of Power.</Tooltip>
            
            In 1852 Brigham stated, “The Lord God Almighty has set up a kingdom that will sway the scepter of power and authority over 
            all the kingdoms of the world, and will never be destroyed, it is the kingdom that Daniel saw and wrote of. It may be 
            considered treason to say that the kingdom which that Prophet foretold is actually set up; … The kingdom will continue to 
            increase, to grow, to spread and prosper more and more … and become more wonderful and conspicuous to the nations, until 
            it fills the whole earth.”
            <btn id="clickable33" className="footnote">33  </btn>
            <Tooltip anchorSelect="#clickable33" className="footnote-size" clickable>Brigham Young, Journal of Discourses, April 6, 1852, vol. 1, p. 202-203.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Brigham stated of the Mormon Kingdom of God in 1859, “… there is no true government on earth but the government of God, or 
            the holy Priesthood … In short, it is a perfect system of government – a kingdom of Gods and angels and all beings who will 
            submit themselves to that government. There is no other true government in heaven or upon the earth.”  
            <btn id="clickable34" className="footnote">34  </btn>
            <Tooltip anchorSelect="#clickable34" className="footnote-size" clickable>Brigham Young, Journal of Discourses, May 22, 1859, vol. 7. P. 139-147.</Tooltip>
            
            First Presidency Counselor Heber Kimball alluded to Brigham’s anointing as “King, Priest, and Ruler over Israel on the 
            Earth” succeeding Joseph. “The church and kingdom to which we belong will become the kingdom of our God and his Christ, 
            and brother Brigham Young will become president of the United States. (Voices in the crowd responded, “Amen”) and I tell 
            you he will be something more, but we do not now want to give him the name, but he is called and ordained to a far greater 
            station.”  
            <btn id="clickable35" className="footnote">35  </btn>
            <Tooltip anchorSelect="#clickable35" className="footnote-size" clickable>Heber Kimball, Journal of Discourses, September 6, 1856, vol. 5, p. 219.</Tooltip>

            That station was as “King, Priest, and Ruler over Israel on the Earth.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Andrew Cahoon, son of an original Council of Fifty member, testified in 1889 that Brigham Young had proclaimed himself as 
            king to the 1847 pioneers in Utah.  
            <btn id="clickable36" className="footnote">36 </btn>
            <Tooltip anchorSelect="#clickable36" className="footnote-size" clickable>Testimony of Andrew Cahoon, Deseret Evening News, 14 November 1889. </Tooltip>
            
            William smith wrote, “the people of Salt Lake govern their church by a secret lodge of 
            50 men, it is in this lodge that Brigham Young is crowned as a king and is there seated upon a throne prepared for him.”
            <btn id="clickable37" className="footnote">37 </btn>
            <Tooltip anchorSelect="#clickable37" className="footnote-size" clickable>Melchizedek and Aaronic Herald, 1 [February 1850]: 1.</Tooltip> 
          </p>
        </div>

        <h2 className="headlinePadding">John Taylor’s Coronation as King of the World</h2>

        <div className='paragraph'>
          <p>Third Mormon prophet, John Taylor, was anointed as “King, Priest, and Ruler over Israel on the Earth” on February 4, 1885. 
            It was recorded, “… president Taylor stated the object of the council. Directed br. Nuttall to read a revelation which he 
            [John Taylor] said he received more than a year ago requiring him to be anointed & set apart as a king priest and ruler over 
            Israel on the earth over Zion & the Kingdom of Christ our King of Kings … FM Lyman motioned that we proceed to obey the 
            requirement of the revelation. When we clothed in our priestly attire, Erastus Snow offered prayer when after the usual 
            ceremony, FM Lyman prayed in the circle. L snow consecrated a bottle of oil. Counselor Cannon anointed President John Taylor, 
            and we all laid hands on the Prest & George Q sealed the anointing according to a written form which had been prepared.”
            <btn id="clickable38" className="footnote">38 </btn>
            <Tooltip anchorSelect="#clickable38" className="footnote-size" clickable>Manuscript in Franklin D. Richards Miscellaneous Papers, Church Archines. Franklin D. Richards Journal, 4 February 1885, reads: “At 8. P.m. attended Council at Endowment House where we had prayers consecrated oil, and Prest. Jno Taylor was anointed K. P. R. Of C. Z. & K.” (King, Priest, Ruler of Church, Zion, & Kingdom.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>As corroborating evidence, The Salt Lake Tribune reported that George Cannon had assisted at the coronation of John Taylor 
            as King of the Mormon commonwealth.
            <btn id="clickable39" className="footnote">39 </btn>
            <Tooltip anchorSelect="#clickable39" className="footnote-size" clickable>“That Declaration” Salt Lake Tribune, 5 May 1885. Earlier references to this ceremony by the Salt Lake Tribune appeared in articles “Is Mormonism Treason?” (8 March 1885) and “They Talk It Over” (10 March 1885). </Tooltip> 
          </p>
        </div>

        <h2 className="headlinePadding">Relocating the Kingdom of God</h2>

        <div className='paragraph'>
          <p>The Mormons had met opposition practicing their strange religion in every area they resided – New York, Ohio, Missouri, 
            and Illinois. They were not innocent bystanders, often clashing with their neighbors resulting in Mormon violence and crime. 
            In their 11 March 1844 minutes, the Council of Fifty discussed establishing a settlement outside the United States. 
            “All seemed agreed to look to some place where we can go and establish a theocracy either in Texas or Oregon or somewhere 
            in California.” 
            <btn id="clickable40" className="footnote">40 </btn>
            <Tooltip anchorSelect="#clickable40" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 25.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph and the Council of Fifty believed it was time to leave the United States to escape state and local governments they saw 
            as unwilling to protect the rights of religious minorities. In spring 1845, W.W. Phelps said before the Council of Fifty, “[W]hat 
            is the patriotism of these United States – fifteen thousand souls driven from their homes in Missouri and no means made use of to 
            restore them to us, or redress our wrongs and to finish off with, they have spilt our best blood.”  
            <btn id="clickable41" className="footnote">41 </btn>
            <Tooltip anchorSelect="#clickable41" className="footnote-size" clickable>Joseph Smith Papers: Council of Fifty Minutes, March 1844-January 1846, 59.</Tooltip> 
            
            Heber Kimball made a motion 
            before the Council “that we declare ourselves an independent nation.” Orson Pratt replied, “He did not think it necessary 
            inasmuch as the nation has already made us independent.”
          </p>
        </div>

        <div className='paragraph'>
          <p>John Taylor, third Mormon prophet, and third person to be crowned as King of the Council of Fifty, received a revelation on 
            27 June 1882 that explains the Council of Fifty’s purpose. “Thus, saith the lord god who rules in the heavens above and in the 
            earth beneath. I have introduced my kingdom and my government even the kingdom of god that my servants have heretofore prophesied 
            of and that I taught my disciples to pray for saying thy kingdom come thy will be done on earth as it is in heaven for the 
            establishment of my rule for the introduction of my law for the protection of my church and for the maintenance promulgation 
            and protection of civil and religious liberty in this nation and throughout the world and all men of every nation color and creed 
            shall yet be protected and shielded thereby and every nation and kindred and people and tongue shall yet bow the knee to me and 
            acknowledge me to be Ahman Christ to the glory of god the father.” 
            <btn id="clickable42" className="footnote">42 </btn>
            <Tooltip anchorSelect="#clickable42" className="footnote-size" clickable>Annie Taylor Hyde notebook pp 58-60; see also franklin D Richard’s Journal and John Henry Smith for 27 June 1882.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>By March 1844, opposition toward Joseph and the church in and around Nauvoo was its highest point. This was largely due, in part, to rumors of polygamy and the Mormons’ growing political power as devoted converted poured into the area. Outside the United States, the Mormons could create their own theocratic government – free to practice their religion as they pleased. 
          </p>
        </div>

        </div>

        <div className="chapterFooter">
        <Link to="/Chap22">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap24">Next</Link>
      </div>
      
    </div>
  )
}

export default Chap23